// actions.js
export default {
  openBottomCanvasAction({ commit }, payload) {
    commit('openBottomCanvasCommit', payload);
  },
  setUserInStore({ commit }, user) {
    commit('setUser', user);
  },
  setProfilePhotoURL({ commit }, url) {
    commit('setProfilePhotoURL', url);
  },
  setSelectedOrg({ commit }, selectedOrg) {
    commit('setSelectedOrg', selectedOrg);
  },
  setSelectedAssessment({ commit }, selectedAssessment) {
    commit('setSelectedAssessment', selectedAssessment);
  },
  setFilteredAssessments({ commit }, filteredAssessments) {
    commit('setFilteredAssessments', filteredAssessments);
  },
  setAssessments({ commit }, assessments) {
    commit('setAssessments', assessments);
  },
  setOrganisations({ commit }, organisations) {
    commit('setOrganisations', organisations);
  },
  setCurrentSection({ commit }, currentSection) {
    commit('setCurrentSection', currentSection);
  },
  setAssessmentUserResponses({ commit }, responses) {
    commit('setAssessmentUserResponses', responses);
  },
  setAssessmentReviewUserResponses({ commit }, responses) {
    commit('setAssessmentReviewUserResponses', responses);
  },
  setQuestions({ commit }, questions) {
    commit('setQuestions', questions);
  },
  async clearState({ commit, dispatch }) {
    // Clear user data
    commit('clearGlobalState');

    // Call the auth module's logout action to clear auth state
    await dispatch('auth/logout');
  },
  async fetchUser({ commit }, { api, email }) {
    try {
      // Example: Fetch user data from an API or Firebase
      const response = await api.get(`/users?email=${email}`);
      commit('setUser', response.data); // Assume 'setUser' mutation saves user data in state
      return response.data;
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      throw error;
    }
  },
};
